// Vendor imports
const _ = require('lodash')
const { createSelector } = require('reselect')
// Client V2 common imports
const promoSelectors = require('client-v2/common/containers/promo-badge/selectors')
const { FetchStateEnum } = require('client-v2/common/utils/enums')

const containerState = state => state.contentAddModal

// Article selectors

const isVisible = createSelector(
  containerState,
  s => Boolean(s && s.isVisible)
)

const article = createSelector(
  containerState,
  s => _.get(s, 'article')
)

const postHref = createSelector(
  containerState,
  s => _.get(s, 'postHref')
)

const urlId = createSelector(
  article,
  a => _.get(a, 'url_id')
)

const url = createSelector(
  containerState,
  s => _.get(s, 'url')
)

const isArticleLoaded = createSelector(
  containerState,
  s => Boolean(s && s.articleState === FetchStateEnum.LOADED)
)

const isArticleLoading = createSelector(
  containerState,
  s => Boolean(s && _.every([
    !!s.url,
    !s.isUrlInvalid,
    s.articleState !== FetchStateEnum.LOADED,
    s.articleState !== FetchStateEnum.FAILED
  ]))
)

const isArticleFailed = createSelector(
  containerState,
  s => Boolean(s && s.articleState === FetchStateEnum.FAILED)
)

const isCollectionsModalVisible = createSelector(
  containerState,
  s => Boolean(s && s.isCollectionsModalVisible)
)

const isUrlInvalid = createSelector(
  containerState,
  s => Boolean(s && s.isUrlInvalid)
)

const isSubmitPending = createSelector(
  containerState,
  s => Boolean(s && s.isSubmitPending)
)

const errorMessage = createSelector(
  [isArticleFailed, isUrlInvalid],
  (isArticleFailed, isUrlInvalid) => {
    if (isArticleFailed) {
      return 'Sorry, we couldn’t gather information from this website.'
    }
    if (isUrlInvalid) {
      return 'Sorry, that looks like an invalid URL.'
    }
  }
)

function createPromoSelector() {
  const promoForIdSelector = promoSelectors.createPromoForIdSelector()
  return createSelector(
    [
      state => state.env.extensionInstalled,
      promoSelectors.browserPromoSelector,
      state => promoForIdSelector(state, 'chrome')
    ],
    (isExtensionInstalled, browserPromo, fallbackPromo) => {
      if (!isExtensionInstalled) {
        return browserPromo || fallbackPromo
      }
    }
  )
}

module.exports = {
  // Factories
  createPromoSelector,
  // Selectors
  article,
  containerState,
  errorMessage,
  isArticleLoaded,
  isArticleLoading,
  isArticleFailed,
  isCollectionsModalVisible,
  isSubmitPending,
  isUrlInvalid,
  isVisible,
  postHref,
  url,
  urlId
}
